/** Canonical English message catalog. Every localized catalog must match these keys. */
export const EN_US_MESSAGES = Object.freeze({
  'common.actions.cancel': 'Cancel',
  'common.actions.close': 'Close',
  'common.actions.edit': 'Edit',
  'common.actions.archive': 'Archive',
  'common.actions.retry': 'Retry',
  'common.actions.save': 'Save',
  'common.errors.generic': 'Something went wrong.',
  'common.errors.required': 'This field is required.',
  'common.status.loading': 'Loading…',
  'common.status.unavailable': 'Unavailable',
  'locale.english': 'English',
  'locale.polish': 'Polish',
  'products.add': 'Add product',
  'products.archive.confirm': 'Archive this product?',
  'products.archive.failure': 'Failed to archive: {message}',
  'products.empty.body':
    'Create products directly on Kloutsale, or connect a store to import products.',
  'products.empty.connectStore': 'Connect store',
  'products.empty.create': 'Create product',
  'products.empty.title': 'No products yet',
  'products.fulfillment.all': 'All fulfillment',
  'products.fulfillment.external': 'Warehouse / 3PL',
  'products.fulfillment.manual': 'Manual',
  'products.fulfillment.shopify': 'Shopify',
  'products.filters.fulfillment': 'Filter by fulfillment',
  'products.filters.sort': 'Sort products',
  'products.filters.status': 'Filter by status',
  'products.load.failure': 'Failed to load products: {message}',
  'products.price.currencyUnavailable': 'Currency unavailable',
  'products.search': 'Search products',
  'products.sort.newest': 'Newest',
  'products.sort.price': 'Price',
  'products.sort.title': 'Title',
  'products.status.all': 'All',
  'products.status.approved': 'Approved',
  'products.status.archived': 'Archived',
  'products.status.draft': 'Draft',
  'products.status.flagged': 'Flagged',
  'products.status.pendingReview': 'Pending review',
  'products.status.rejected': 'Rejected',
  'products.source.native': 'Kloutsale',
  'products.source.other': 'Connected store',
  'products.source.rakuten': 'Rakuten',
  'products.source.shopify': 'Shopify',
  'products.source.woocommerce': 'WooCommerce',
  'products.actions.archiveAria': 'Archive product',
  'products.actions.editAria': 'Edit product',
  'products.title': 'Products',
  'products.untitled': 'Untitled product',
} as const);

export type MessageKey = keyof typeof EN_US_MESSAGES;
